<template>
	<div class="menuContentBox" @mouseleave="levFData()">
		<div class="correntItem" ref="corrent1"  :class="{activeShow:showF==1}" @mouseover="showFData(1)" >
			<h3><img src="@/assets/img/jf/1.png">种子期</h3>
			<table class="tableClass">
				<tr>
						<th>排名</th>
						<th>企业名称</th>
						<th>分数</th>
				</tr>
				<tr>
						<td><img src="@/assets/img/jf/bang1.png" alt=""></td>
						<td><span v-if="dataA[0]">{{ellipsis(dataA[0].companyName)}}</span></td>
						<td><span v-if="dataA[0]&&dataA[0].isFb">{{dataA[0].totalScore}}</span></td>
				</tr>
				<tr>
						<td><img src="@/assets/img/jf/bang2.png" alt=""></td>
						<td><span v-if="dataA[1]">{{ellipsis(dataA[1].companyName)}}</span></td>
						<td><span v-if="dataA[1]">{{dataA[1].totalScore}}</span></td>
				</tr>
				<tr>
						<td><img src="@/assets/img/jf/bang3.png" alt=""></td>
						<td><span v-if="dataA[2]">{{ellipsis(dataA[2].companyName)}}</span></td>
						<td><span v-if="dataA[2]">{{dataA[2].totalScore}}</span></td>
				</tr>
			</table>
			<div class="bottom-table"  v-if="botDataShowa">
				<table class="tableClass" ref="botTable0">
					<a-carousel arrows autoplay dots="false" dotPosition="right"
                                :slides-to-show="5" :slides-to-scroll="1">
					<tr v-for="(item,index) in dataA.slice(3)" :key="index">
							<td  width="155px">{{index+4}}</td>
							<td><span>{{ellipsis(item.companyName)}}</span></td>
							<td><span v-if="item.isFb">{{item.totalScore}}</span></td>
					</tr>
					</a-carousel>
				</table>
			</div>
		</div>
		
		<div class="correntItem" ref="corrent1">
			
				<h3><img src="@/assets/img/jf/1.png">种子期</h3>
				<table class="tableClass">
					<tr>
							<th>排名</th>
							<th>企业名称</th>
							<th>分数</th>
					</tr>
					<tr>
							<td><img src="@/assets/img/jf/bang1.png" alt=""></td>
							<td><span v-if="dataA[0]">{{ellipsis(dataA[0].companyName)}}</span></td>
							<td><span v-if="dataA[0]&&dataA[0].isFb">{{dataA[0].totalScore}}</span></td>
					</tr>
					<tr>
							<td><img src="@/assets/img/jf/bang2.png" alt=""></td>
							<td><span v-if="dataA[1]">{{ellipsis(dataA[1].companyName)}}</span></td>
							<td><span v-if="dataA[1]">{{dataA[1].totalScore}}</span></td>
					</tr>
					<tr>
							<td><img src="@/assets/img/jf/bang3.png" alt=""></td>
							<td><span v-if="dataA[2]">{{ellipsis(dataA[2].companyName)}}</span></td>
							<td><span v-if="dataA[2]">{{dataA[2].totalScore}}</span></td>
					</tr>
				</table>
				<div class="bottom-table"  v-if="botDataShowa">
					<table class="tableClass" ref="botTable0">
						<a-carousel arrows autoplay dots="false" dotPosition="right"
																	:slides-to-show="5" :slides-to-scroll="1">
						<tr v-for="(item,index) in dataA.slice(3)" :key="index">
								<td  width="155px">{{index+4}}</td>
								<td><span>{{ellipsis(item.companyName)}}</span></td>
								<td><span v-if="item.isFb">{{item.totalScore}}</span></td>
						</tr>
						</a-carousel>
					</table>
				</div>
		</div>
		<div class="correntItem" ref="corrent2"  :class="{activeShow:showF==2}" @mouseover="showFData(2)">
			<h3><img src="@/assets/img/jf/2.png">成熟期</h3>
			<table class="tableClass">
				<tr>
						<th>排名</th>
						<th>企业名称</th>
						<th>分数</th>
				</tr>
				<tr>
						<td><img src="@/assets/img/jf/bang1.png" alt=""></td>
						<td><span v-if="dataD[0]">{{ellipsis(dataD[0].companyName)}}</span></td>
						<td><span v-if="dataD[0]&&dataD[0].isFb">{{dataD[0].totalScore}}</span></td>
				</tr>
				<tr>
						<td><img src="@/assets/img/jf/bang2.png" alt=""></td>
						<td><span v-if="dataD[1]">{{ellipsis(dataD[1].companyName)}}</span></td>
						<td><span v-if="dataD[1]">{{dataD[1].totalScore}}</span></td>
				</tr>
				<tr>
						<td><img src="@/assets/img/jf/bang3.png" alt=""></td>
						<td><span v-if="dataD[2]">{{ellipsis(dataD[2].companyName)}}</span></td>
						<td><span v-if="dataD[2]">{{dataD[2].totalScore}}</span></td>
				</tr>
			</table>
			<div class="bottom-table"  v-if="botDataShowa">
				<table class="tableClass" ref="botTable1">
					<a-carousel arrows autoplay dots="false" dotPosition="right"
                                :slides-to-show="5" :slides-to-scroll="1">
					<tr v-for="(item,index) in dataD.slice(3)" :key="index">
						<td  width="155px">{{index+4}}</td>
						<td ><span>{{ellipsis(item.companyName)}}</span></td>
						<td ><span v-if="item.isFb">{{item.totalScore}}</span></td>
				</tr>
				</a-carousel>
				</table>
			</div>
		</div>
		
		<div class="correntItem" ref="corrent2">
			<h3><img src="@/assets/img/jf/2.png">成熟期</h3>
			<table class="tableClass">
				<tr>
						<th>排名</th>
						<th>企业名称</th>
						<th>分数</th>
				</tr>
				<tr>
						<td><img src="@/assets/img/jf/bang1.png" alt=""></td>
						<td><span v-if="dataD[0]">{{ellipsis(dataD[0].companyName)}}</span></td>
						<td><span v-if="dataD[0]&&dataD[0].isFb">{{dataD[0].totalScore}}</span></td>
				</tr>
				<tr>
						<td><img src="@/assets/img/jf/bang2.png" alt=""></td>
						<td><span v-if="dataD[1]">{{ellipsis(dataD[1].companyName)}}</span></td>
						<td><span v-if="dataD[1]">{{dataD[1].totalScore}}</span></td>
				</tr>
				<tr>
						<td><img src="@/assets/img/jf/bang3.png" alt=""></td>
						<td><span v-if="dataD[2]">{{ellipsis(dataD[2].companyName)}}</span></td>
						<td><span v-if="dataD[2]">{{dataD[2].totalScore}}</span></td>
				</tr>
			</table>
			<div class="bottom-table"  v-if="botDataShowa">
				<table class="tableClass" ref="botTable1">
					<a-carousel arrows autoplay dots="false" dotPosition="right"
                                :slides-to-show="5" :slides-to-scroll="1">
					<tr v-for="(item,index) in dataD.slice(3)" :key="index">
						<td  width="155px">{{index+4}}</td>
						<td ><span>{{ellipsis(item.companyName)}}</span></td>
						<td ><span v-if="item.isFb">{{item.totalScore}}</span></td>
				</tr>
				</a-carousel>
				</table>
			</div>
		</div>
		<div class="correntItem" ref="corrent3"  :class="{activeShow:showF==3}" @mouseover="showFData(3)" >
			<h3><img src="@/assets/img/jf/3.png">成长期</h3>
			<table class="tableClass">
				<tr>
						<th>排名</th>
						<th>企业名称</th>
						<th>分数</th>
				</tr>
				<tr>
						<td><img src="@/assets/img/jf/bang1.png" alt=""></td>
						<td><span v-if="dataC[0]">{{ellipsis(dataC[0].companyName)}}</span></td>
						<td><span v-if="dataC[0]&&dataC[0].isFb">{{dataC[0].totalScore}}</span></td>
						<!-- <td><span v-if="dataC[0]&&dataC[0].isFb">{{dataC[0].totalScore}}</span></td> -->
				</tr>
				<tr>
						<td><img src="@/assets/img/jf/bang2.png" alt=""></td>
						<td><span v-if="dataC[1]">{{ellipsis(dataC[1].companyName)}}</span></td>
						<td><span v-if="dataC[1]&&dataC[1].isFb">{{dataC[1].totalScore}}</span></td>
				</tr>
				<tr>
						<td><img src="@/assets/img/jf/bang3.png" alt=""></td>
						<td><span v-if="dataC[2]">{{ellipsis(dataC[2].companyName)}}</span></td>
						<td><span v-if="dataC[2]&&dataC[2].isFb">{{dataC[2].totalScore}}</span></td>
				</tr>
			</table>
			<div class="bottom-table"  v-if="botDataShowa">
				<table class="tableClass" ref="botTable2">
					<a-carousel arrows autoplay dots="false" dotPosition="right"
                                :slides-to-show="5" :slides-to-scroll="1">
					<tr v-for="(item,index) in dataC.slice(3)" :key="index">
							<td >{{index+4}}</td>
							<td ><span>{{ellipsis(item.companyName)}}</span></td>
							<td ><span v-if="item.isFb">{{item.totalScore}}</span></td>
					</tr>
					</a-carousel>
				</table>
			</div>
		</div>
		
		<div class="correntItem" ref="corrent3">
			<h3><img src="@/assets/img/jf/3.png">成长期</h3>
			<table class="tableClass">
				<tr>
						<th>排名</th>
						<th>企业名称</th>
						<th>分数</th>
				</tr>
				<tr>
						<td><img src="@/assets/img/jf/bang1.png" alt=""></td>
						<td><span v-if="dataC[0]">{{ellipsis(dataC[0].companyName)}}</span></td>
						<td><span v-if="dataC[0]&&dataC[0].isFb">{{dataC[0].totalScore}}</span></td>
						<!-- <td><span v-if="dataC[0]&&dataC[0].isFb">{{dataC[0].totalScore}}</span></td> -->
				</tr>
				<tr>
						<td><img src="@/assets/img/jf/bang2.png" alt=""></td>
						<td><span v-if="dataC[1]">{{ellipsis(dataC[1].companyName)}}</span></td>
						<td><span v-if="dataC[1]&&dataC[1].isFb">{{dataC[1].totalScore}}</span></td>
				</tr>
				<tr>
						<td><img src="@/assets/img/jf/bang3.png" alt=""></td>
						<td><span v-if="dataC[2]">{{ellipsis(dataC[2].companyName)}}</span></td>
						<td><span v-if="dataC[2]&&dataC[2].isFb">{{dataC[2].totalScore}}</span></td>
				</tr>
			</table>
			<div class="bottom-table"  v-if="botDataShowa">
				<table class="tableClass" ref="botTable2">
					<a-carousel arrows autoplay dots="false" dotPosition="right"
                                :slides-to-show="5" :slides-to-scroll="1">
					<tr v-for="(item,index) in dataC.slice(3)" :key="index">
							<td >{{index+4}}</td>
							<td ><span>{{ellipsis(item.companyName)}}</span></td>
							<td ><span v-if="item.isFb">{{item.totalScore}}</span></td>
					</tr>
					</a-carousel>
				</table>
			</div>
		</div>
		<div class="correntItem" ref="corrent4"  :class="{activeShow:showF==4}" @mouseover="showFData(4)">
			<h3><img src="@/assets/img/jf/4.png">初创期</h3>
			<table class="tableClass">
				<tr>
						<th>排名</th>
						<th>企业名称</th>
						<th>分数</th>
				</tr>
				<tr>
						<td><img src="@/assets/img/jf/bang1.png" alt=""></td>
						<td><span v-if="dataB[0]">{{ellipsis(dataB[0].companyName)}}</span></td>
						<td><span v-if="dataB[0]&&dataB[0].isFb">{{dataB[0].totalScore}}</span></td>
				</tr>
				<tr>
						<td><img src="@/assets/img/jf/bang2.png" alt=""></td>
						<td><span v-if="dataB[1]">{{ellipsis(dataB[1].companyName)}}</span></td>
						<td><span v-if="dataB[1]">{{dataB[1].totalScore}}</span></td>
				</tr>
				<tr>
						<td><img src="@/assets/img/jf/bang3.png" alt=""></td>
						<td><span v-if="dataB[2]">{{ellipsis(dataB[2].companyName)}}</span></td>
						<td><span v-if="dataB[2]">{{dataB[2].totalScore}}</span></td>
				</tr>
			</table>
			<div class="bottom-table"  v-if="botDataShowa">
				<table class="tableClass" ref="botTable3">
					
					<a-carousel arrows autoplay dots="false" dotPosition="right"
                                :slides-to-show="5" :slides-to-scroll="1">
					<tr v-for="(item,index) in dataB.slice(3)" :key="index">
							<td width="155px">{{index+4}}</td>
							<td><span>{{ellipsis(item.companyName)}}</span></td>
							<td><span v-if="item.isFb">{{item.totalScore}}</span></td>
					</tr>
					</a-carousel>
				</table>
			</div>
		</div>
		
		<div class="correntItem" ref="corrent4">
			<h3><img src="@/assets/img/jf/4.png">初创期</h3>
			<table class="tableClass">
				<tr>
						<th>排名</th>
						<th>企业名称</th>
						<th>分数</th>
				</tr>
				<tr>
						<td><img src="@/assets/img/jf/bang1.png" alt=""></td>
						<td><span v-if="dataB[0]">{{ellipsis(dataB[0].companyName)}}</span></td>
						<td><span v-if="dataB[0]&&dataB[0].isFb">{{dataB[0].totalScore}}</span></td>
				</tr>
				<tr>
						<td><img src="@/assets/img/jf/bang2.png" alt=""></td>
						<td><span v-if="dataB[1]">{{ellipsis(dataB[1].companyName)}}</span></td>
						<td><span v-if="dataB[1]">{{dataB[1].totalScore}}</span></td>
				</tr>
				<tr>
						<td><img src="@/assets/img/jf/bang3.png" alt=""></td>
						<td><span v-if="dataB[2]">{{ellipsis(dataB[2].companyName)}}</span></td>
						<td><span v-if="dataB[2]">{{dataB[2].totalScore}}</span></td>
				</tr>
			</table>
			<div class="bottom-table"  v-if="botDataShowa">
				<table class="tableClass" ref="botTable3">
					
					<a-carousel arrows autoplay dots="false" dotPosition="right"
                                :slides-to-show="5" :slides-to-scroll="1">
					<tr v-for="(item,index) in dataB.slice(3)" :key="index">
							<td width="155px">{{index+4}}</td>
							<td><span>{{ellipsis(item.companyName)}}</span></td>
							<td><span v-if="item.isFb">{{item.totalScore}}</span></td>
					</tr>
					</a-carousel>
				</table>
			</div>
		</div>
		<div class="btnStart" @click="btnStart"></div>
	</div>
</template>

<script>
import {companyPointsSystem} from "@/api/integral";
// import animationConfig from "@/config/animationConfig";
export default {
name: "index",
components: {
	// DictRender
},
data() {
	return {
		showF:null,
		botDataShowa:false,
		dataA:[],
		dataB:[],
		dataC:[],
		dataD:[],
	}
},
mounted() {
	this.getBannerList()
},
methods: {
	showFData(num){
		this.showF = num
	},
	levFData(){
		this.showF = null
	},
	ellipsis(value){
          if (!value) return '';
          if (value.length > 12) {
            return value.slice(0,12) + '...'
          }
          return value
        },
	getBannerList() {
		this.getAction({
			url: companyPointsSystem.getWebType,
		}).then(res => {
			
			this.botDataShowa = true
			this.dataA = res.A
			this.dataB = res.B
			this.dataC = res.C
			this.dataD = res.D
			this.$refs.botTable3.style.height = res.D.length*52+'px'
		})
	},
}
}
</script>

<style scoped lang="less">
.menuContentBox{
position: relative;
height:560px!important;
width:1400px!important;
margin:30px auto!important;
}
.correntItem{
cursor: pointer;
position: absolute;
top:0;
left:0;
box-shadow: 1px 2px 5px 1px #d4d8d8;
width:420px;
height:560px;
h3{
	font-size: 25px;
	font-weight: 600;
	text-align: center;
	margin-bottom: 10px;
	img{
		margin-right: 10px;
	}
}
.bottom-table{
	height:182px;
	overflow: hidden;
	.tableClass{
		tr{
			width:376px!important;
			height:60px;
			margin-bottom: -8px;
		}
		td:nth-child(1){
			width:73px;
		}
		td:nth-child(2){
			width:228px;
		}
		td:nth-child(3){
			width:73px;
		}
	}
	width:100%;
	z-index: 1;
	position: relative;
}
&:nth-child(1){
	background: #ffffff;
	padding:10px 22px;
	z-index: 4;
	height:500px;
	overflow: hidden;
	margin-top: 30px;
	margin-left:1px;
	opacity: 1;
}
&:nth-child(2){
	background: #ffffff;
	padding:10px 22px;
	z-index: 3;
	height:500px;
	overflow: hidden;
	margin-top: 30px;
	margin-left:1px;
	opacity: 1;
}
&:nth-child(3){
	background: #ffffff;
	padding:10px 22px;
	z-index: 9;
	margin-left:280px;
	margin-top: 0px;
	height:560px;
	overflow: hidden;
}
&:nth-child(4){
	background: #ffffff;
	padding:10px 22px;
	z-index: 8;
	margin-left:280px;
	margin-top: 0px;
	height:560px;
	overflow: hidden;
}
&:nth-child(5){
	background: #ffffff;
	padding:10px 22px;
	z-index: 9;
	margin-left:700px;
	height:560px;
	margin-top: 0px;
	overflow: hidden;
}
&:nth-child(6){
	background: #ffffff;
	padding:10px 22px;
	z-index: 8;
	margin-left:700px;
	height:560px;
	margin-top: 0px;
	overflow: hidden;
}
&:nth-child(7){
	background: #ffffff;
	padding:10px 22px;
	z-index: 4;
	margin-left:980px;
	height:500px;
	margin-top: 30px;
	overflow: hidden;
}
&:nth-child(8){
	background: #ffffff;
	padding:10px 22px;
	z-index: 3;
	margin-left:980px;
	height:500px;
	margin-top: 30px;
	overflow: hidden;
}
}


.activeShow{
	.bottom-table{
		
	height:320px;
		.tableClass{
			tr{
				height:60px;
				width:514px!important;
				margin-bottom: -8px;
			}
			td:nth-child(1){
				width:99px!important;
			}
			td:nth-child(2){
				width:315px!important;
			}
			td:nth-child(3){
				width:99px!important;
			}
		}
	}
	z-index: 999!important;
	width:560px;
	box-shadow: 1px 1px 5px 1px #4ea8fc;
	margin-left:413px!important;
	height:630px!important;
	margin-top: -30px!important;
	overflow: hidden!important;
	transition: width .3s,height .3s,margin-left .3s,margin-top .3s;
}
.tableClass{
overflow: auto;
z-index: 9;
width:100%;
height:200px;
position: relative;
background: #ffffff;
color:#333333;width:100%;border-width: 1px;border-color: #e9e9e9;border-collapse: collapse;font-size: 16px;
th {border-width: 1px;border-style: solid;height:30px;border-color: #e9e9e9;text-align:center;}
td {border-width: 1px;text-align: center; height:60px!important; line-height: 60px!important; font-size: 14px!important; border-style: solid;border-color: #e9e9e9;
img{
	width:34px;
}
}
tr:nth-child(odd){
	background: rgba(10,135,223,.03);
}
td:nth-child(1){
	width:80px;
}
td:nth-child(2){
	width:250px;
}
td:nth-child(3){
	width:80px;
	font-size: 20px;
	font-family: 'Aldrich-Regular';
	color:rgb(255, 100, 44);
	font-weight: 600;
}
}

:deep(.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected::after) {
border-bottom: 3px solid #1890ff
}

:deep(.ant-menu-item-selected) {
font-weight: 600;
}

:deep(.ant-btn) {
border-radius: 0;
}
</style>